import type { ReactNode } from 'react';
import { useCallback } from 'react';

import { FormSelect } from '@/_components';
import type { RSelectProps } from '@/_components';

import { PriorityBadge } from './priority-badge';

import { priorityOptions } from '../schemas/support-query-schema';

type PriorityOption = {
  value: string;
  label: string;
};

type FormSupportPriorityMultiSelectProps = Omit<RSelectProps<PriorityOption, true>, 'options' | 'isMulti'> & {
  formItemClassName?: string;
  menuListClassName?: string;
};

export function FormSupportPriorityMultiSelect(props: FormSupportPriorityMultiSelectProps) {
  const getOptionLabel = useCallback((option: PriorityOption): ReactNode => {
    return <PriorityBadge priority={Number(option.value)} variant="box" />;
  }, []);

  const options = priorityOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  return <FormSelect {...props} options={options} isMulti getOptionLabel={getOptionLabel} menuPortalTarget={null} />;
}
